import React, { useState, useMemo, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Dropdown, AboutContent, withModal, Icon } from '@ohif/ui';
//
import { UserPreferences } from './../UserPreferences';
import OHIFLogo from '../OHIFLogo/OHIFLogo.js';
import './Header.css';

function Header(props) {
  const {
    t,
    user,
    userManager,
    modal: { show },
    useLargeLogo,
    linkPath,
    linkText,
    location,
    children,
    history,
  } = props;

  const [options, setOptions] = useState([]);
  const hasLink = linkText && linkPath;
  const isRresearch = useMemo(
    () => location.pathname.search(/^\/research/) >= 0,
    [location.pathname]
  );

  useEffect(() => {
    const optionsValue = [
      {
        title: t('About'),
        icon: { name: 'info' },
        onClick: () =>
          show({
            content: AboutContent,
            title: t('OHIF Viewer - About'),
          }),
      },
      {
        title: t('Preferences'),
        icon: {
          name: 'user',
        },
        onClick: () =>
          show({
            content: UserPreferences,
            title: t('User Preferences'),
          }),
      },
    ];

    if (user && userManager) {
      optionsValue.push({
        title: t('Logout'),
        icon: { name: 'power-off' },
        onClick: () => userManager.signoutRedirect(),
      });
    }

    setOptions(optionsValue);
  }, [setOptions, show, t, user, userManager]);

  const logout = () => {
    localStorage.clear();
    history.push('/login');
    // setTimeout(() => {
    //   this.router.navigate(['/public/store/list'], { queryParams: { returnUrl: this.router.url } });
    //   localStorage.clear();
    // })
  };

  return (
    <>
      {/* 演示用途 */}
      <div className="notification-bar" onClick={logout}>
        退出
      </div>
      <div
        className={classNames('entry-header', { 'header-big': useLargeLogo })}
      >
        <div className="header-left-box">
          {location && location.studyLink && (
            <Link
              to={location.studyLink}
              className="header-btn header-viewerLink"
            >
              {t('Back to Viewer')}
            </Link>
          )}
          <OHIFLogo />
          {children}
          {hasLink && (
            <Link
              className="header-btn header-studyListLinkSection"
              to={{
                pathname: linkPath,
                state: { studyLink: location.pathname },
              }}
            >
              {t(linkText)}
            </Link>
          )}

          {/* {isRresearch && (
            <Link
              className="header-btn header-studyListLinkSection"
              to="/studylist"
            >
              <Icon
                style={{ verticalAlign: 'middle' }}
                width="16px"
                height="16px"
                name="change"
              />
              &nbsp; 切换到: AI阅片器
            </Link>
          )}
          {!isRresearch && (
            <Link
              className="header-btn header-studyListLinkSection"
              to="/research"
            >
              <Icon
                style={{ verticalAlign: 'middle' }}
                width="16px"
                height="16px"
                name="change"
              />
              &nbsp; 切换到: 科研版
            </Link>
          )} */}
        </div>

        <div className="header-menu">
          {/* <span className="research-use" >演示用途</span> */}
          <span
            className="research-use"
            style={{
              cursor: 'pointer',
            }}
            onClick={logout}
          >
            退出
          </span>
          <Dropdown title={t('Options')} list={options} align="right" />
        </div>
      </div>
    </>
  );
}

Header.propTypes = {
  // Study list, /
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  useLargeLogo: PropTypes.bool,
  //
  location: PropTypes.object.isRequired,
  children: PropTypes.node,
  t: PropTypes.func.isRequired,
  userManager: PropTypes.object,
  user: PropTypes.object,
  modal: PropTypes.object,
};

Header.defaultProps = {
  useLargeLogo: false,
};

export default withTranslation(['Header', 'AboutModal'])(
  withRouter(withModal(Header))
);
